export default __webpack_public_path__ + "static/media/gridImage10.191a647f.png";